<template>
  <div>
    <template v-if="!workOrder.isPast">
      <div
          class="link c-gray60 m-r-1"
          selenium="cancel-request-button"
          @click="$emit('showCancelationModal')">
        Cancel <span class="d-none:mo">Request</span>
      </div>|
    </template>
    <router-link
        :to="{ name: 'consumer::triage', params: { jobId } }"
        class="link text-center m-l-1"
        selenium="view-request-link">
      View <span class="d-none:mo">Request</span>
    </router-link>
  </div>
</template>
<script>
import workOrder from '@/mixins/work-order';

export default {
  name: 'service-actions',
  mixins: [
    workOrder,
  ],
  props: {
    // Used by workOrder mixin
    jobId: {
      type: String,
      required: true,
    },
  },
};
</script>
